module.exports = __webpack_public_path__ + "img/logo.dd9aae17.jpg";